import log from "loglevel";
import React, { Component } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configureStore from "./Redux/store";
import Routes from "./Routes";
import { startVersionCheck } from "./Helpers/versionCheck";
import { captureReferralFromUrl } from "./Helpers/referralCode";
import "./Styles.css";

import pkg from "../package.json";

console.log('1');
console.log(process.env.REACT_APP_VERSION);
console.log(process.env.REACT_APP_API);
try {
log.setDefaultLevel(
  process.env.REACT_APP_API.includes("dev") ? "TRACE" : process.env.REACT_APP_API.includes("qa") ? "TRACE" : "WARN"
  );
}
catch(err) {};

  console.log('2');

const store = configureStore();

console.info(
  `Digadop App v${pkg.version}/${process.env.REACT_APP_VERSION}.${process.env.REACT_APP_API}`
);

class App extends Component {
  componentDidMount() {
    // #144: poll for newer deployed builds and prompt long-lived sessions to reload.
    startVersionCheck();
    // #387: capture a referral/reseller code from a `?ref=CODE` partner link on
    // first load and persist it, so it carries to a checkout that may be days away.
    captureReferralFromUrl();
  }

  render() {
    return (
      <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <CookiesProvider>
          <Routes />
        </CookiesProvider>
      </Provider>
    );
  }
}
export default App;
